import {
  GET_CONSTRUCTOR_RECOMMENDATIONS_SUCCESS,
  GET_CONSTRUCTOR_RECOMMENDATIONS_REQUEST,
  GET_CONSTRUCTOR_RECOMMENDATIONS_FAILURE,
} from '../constants/constructor-recommendations';

const initialState = {
  recommendations: {},
};

/**
 *
 * @param {*} state
 * @param {*} action
 * @returns {*}
 */
export function getRecommendedProducts(state = initialState, action) {
  switch (action.type) {
    case GET_CONSTRUCTOR_RECOMMENDATIONS_REQUEST:
      return {
        ...state,
        isFetching: true,
        failedRequest: false,
      };
    case GET_CONSTRUCTOR_RECOMMENDATIONS_SUCCESS:
      return {
        ...state,
        recommendations: action.payload.recommendations,
        isFetching: false,
        failedRequest: false,
      };
    case GET_CONSTRUCTOR_RECOMMENDATIONS_FAILURE:
      return {
        ...state,
        isFetching: false,
        failedRequest: true,
      };
    default:
      return state;
  }
}
